const Translations = {
  step1: {
    titles: [
      {
        id: 'guesty_for_hosts_registration:step_1.heading',
        d: 'Begin Your 14 Day Free Trial Today!',
      },
      {
        id: 'guesty_for_hosts_registration:step_1.sub_heading',
        d: 'No credit card, set up fee or commitment required. Cancel anytime.',
      },
    ],
    form: {
      labels: [
        {
          id: 'guesty_for_hosts_registration:step_1.form_label.first_name',
          d: 'First Name*',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.form_label.last_name',
          d: 'Last Name*',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.form_label.password',
          d: 'Password*',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.form_label.promotionCode',
          d: 'Promotion Code',
        },
      ],
      placeholders: [
        {
          id: 'guesty_for_hosts_registration:step_1.placeholder.first_name',
          d: 'Enter your first name',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.placeholder.last_name',
          d: 'Enter your last name',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.placeholder.password',
          d: 'Create your password',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.placeholder.promotionCode',
          d: 'Enter your promotion code',
        },
      ],
      buttons: [
        {
          id: 'guesty_for_hosts_registration:step_1.button_label.sign_up',
          d: 'SIGN UP',
        },
      ],
      terms: [
        {
          id: 'guesty_for_hosts_registration:step_1.terms',
          d: 'I have read and accept Terms and Conditions and Privacy Policy.',
        },
      ],
      validationErrors: [
        {
          id: 'guesty_for_hosts_registration:step_1.validation.length',
          d: '8 or more characters',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.validation.uppercase',
          d: 'Upper & lowercase letters',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.validation.character',
          d: 'At least 1 special character',
        },
        {
          id: 'guesty_for_hosts_registration:step_1.validation.digit',
          d: 'At least 1 number',
        },
      ],
    },
  },
  step2: {
    titles: [
      {
        id: 'guesty_for_hosts_registration:step_2.heading',
        d: 'We just sent a verification email to',
      },
      {
        id: 'guesty_for_hosts_registration:step_2.sub_heading',
        d: 'Please click on the link in the email to finish activating your account!',
      },
    ],
  },
  step3: {
    titles: [
      {
        id: 'guesty_for_hosts_registration:step_3.heading_v1_l1',
        d: 'Your verification is complete!',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.heading_v1_l2',
        d: 'You can now begin using Guesty For Hosts.',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.heading_v2',
        d: 'Answer these final two questions to finish activating your account!',
      },
    ],
    buttons: [
      {
        id: 'guesty_for_hosts_registration:step_3.button_label.start',
        d: 'CLICK HERE TO LOGIN',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.button_label.start',
        d: 'Download the app:',
      },
    ],
    buttonMessages: [
      {
        id: 'guesty_for_hosts_registration:step_3.button_message_v2',
        d: 'Click below to begin your 14 day free trial!',
      },
    ],
    underButtonMessages: [
      {
        id: 'guesty_for_hosts_registration:step_3.under_button_message_v1',
        d: 'Click to begin your 14 day free trial.',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.under_button_message_v2',
        d: 'No commitment.',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.under_button_message_cancel_text',
        d: 'Cancel anytime.',
      },
    ],
    dropdowns: [
      {
        id: 'guesty_for_hosts_registration:step_3.dropdown_label.country',
        d: 'Country',
      },
      {
        id: 'guesty_for_hosts_registration:step_3.dropdown_label.num_of_listings',
        d: 'Number of Listings',
      },
    ],
  },
  existingEmail: {
    titles: [
      {
        id: 'guesty_for_hosts_registration:existing_email.heading',
        d: 'Oops...hold on!',
      },
      {
        id: 'guesty_for_hosts_registration:existing_email.sub_heading',
        d: 'We noticed this email is already connected with a Guesty For Hosts account. Click below to be taken to the Guesty For Hosts login page.',
      },
    ],
    buttons: [
      {
        id: 'guesty_for_hosts_registration:existing_email.button_label.reset_password',
        d: 'Reset My Password',
      },
    ],
  },
  verificationError: {
    subheading: [
      {
        id: 'guesty_for_hosts_registration:verification_error.subheading',
        d: 'We noticed this account is already verified. Click below to be taken to the Guesty For Hosts login page.',
      },
    ],
  },
};

export default Translations;
